import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL, BASE_URL_PREBID, TEST_URL_PREBID } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";


import usePermission from "../../config/permissions";
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    CrossRed,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    UpdatePencil,
    Eye,
    Reciept
} from "../AllSvg";
import Loader from "../Loader";

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast } from "../custom";

const ApproveInvoiceEditRequest = ({ i, getInvoiceEditRequests }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitApproved = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(
                `${BASE_URL}/project/invoiceupdate/${i.id}/`,
                {
                    bill_date_change: true,
                    req_raised: "approved",
                    hod_update_datetime: new Date().toISOString(),
                    req_approved_by: `${sessionStorage.getItem('employee_id')}-${sessionStorage.getItem('name')}`,
                }
            );

            if (res.status === 200) {
                await getInvoiceEditRequests();
                toast.dismiss(loadingToastId);
                toast.success("Edit Request Approved");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content?.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    return (
        <>
            <button
                title="Approve Timesheet"
                className="model-edit-button"
                onClick={handleShow}
            >
                <CheckGreen />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Approve Invoice Edit Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Give Edit Access for Invoice "{i.invoice_number}"

                        <div className="button-models">
                            <button
                                className="model-button   font-weight500  model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitApproved}
                                className="model-button   font-weight500    model-button-submit"
                            >
                                Approve
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal>
        </>
    );
};

const RejectInvoiceEditRequest = ({ i, getInvoiceEditRequests }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitRejected = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(
                `${BASE_URL}/project/invoiceupdate/${i.id}/`,
                {
                    bill_date_change: true,
                    req_raised: "rejected",
                    hod_update_datetime: new Date().toISOString(),
                    req_approved_by: `${sessionStorage.getItem('employee_id')}-${sessionStorage.getItem('name')}`,
                }
            );
            if (res.status === 200) {
                await getInvoiceEditRequests();
                toast.dismiss(loadingToastId);
                toast.success("Edit Request Rejected");
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="RejectInvoiceEditRequest"
                className="model-delete-button"
                onClick={handleShow}
            >
                <CrossRed />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reject Invoice Edit Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Reject Edit Access for Invoice "{i.invoice_number}"

                        <div className="button-models">
                            <button
                                className="model-button   font-weight500   model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitRejected}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Rejected
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const RequestManagement = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const employee = sessionStorage.getItem("employee_id")
    const [toggleStatus, setToggleStatus] = useState("pending");
    const [timeSheetData, setTimeSheetData] = useState([]);
    const role = sessionStorage.getItem("role");

    const getInvoiceEditRequests = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            // url = `${BASE_URL}/project/timesheetsbyemployee/${role === "HOD" ? "null" : employee}/`;
            url = `${BASE_URL_PREBID}/project/hodgetinvoicerequest/${toggleStatus}/`;

            const sub = await axios.get(url);

            setTimeSheetData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getInvoiceEditRequests();
    }, [toggleStatus]);
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];


    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content?.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    return (
        <>
            <Dashboardnavbarcopy name="Performa Invoice Edit Request" url="RequestMangement" />

            <div className="content-tabs">
                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">
                            Performa Invoice Edit Request
                        </div>
                        <div className="field-cont">
                            <div className="table-searchh-new dropdown-container field-cont-div">
                                <select
                                    onChange={(e) => setToggleStatus(e.target.value)}
                                    value={toggleStatus}
                                    className="dropdown-timesheet font-size-subheading  "
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>


                        </div>
                    </div>
                    <div className="table-box height-73vh">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">Sr. no.</th>
                                    <th className="align-left width-10vw">Invoice No.</th>
                                    <th className="align-center">Client Name</th>
                                    <th className="align-center">Work Order Amount</th>
                                    <th className="align-center">GST</th>
                                    <th className="align-center">Total Amount</th>
                                    <th className="align-center">Billing Percentage</th>
                                    <th className="align-center">Billing Amount</th>
                                    <th className="align-center">Request BY</th>
                                    <th className="align-right">Action</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <Loader />
                            ) : (
                                <tbody>
                                    {timeSheetData
                                        ?.sort((a, b) => new Date(b.req_raised_datetime) - new Date(a.req_raised_datetime))
                                        .map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="tr-border-bottom">
                                                    <td colSpan="6"></td>
                                                </tr>
                                                <tr className="custom-table-head-td">
                                                    <td className="align-left">{index + 1}</td>

                                                    <td className="align-left width-15vw">
                                                        {" "}
                                                        <div dangerouslySetInnerHTML={createMarkup(i.invoice_number)} />
                                                        {/* {i.task_name ? i.task_name : "-"} */}
                                                    </td>

                                                    <td className="align-center">
                                                        {i.client_name ? i.client_name : "-"}
                                                    </td>

                                                    <td className="align-center">
                                                        {i.project_without_gst_amount ? i.project_without_gst_amount : "-"}
                                                    </td>

                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.project_gst_amount ? i.project_gst_amount : "-"}
                                                    </td>

                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.project_woamount ? i.project_woamount : ""}
                                                    </td>

                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.bill_percentage ? `${i.bill_percentage}%` : "-"}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.billamount ? `${i.billamount}` : "-"}
                                                    </td>

                                                    <td className="align-center">
                                                        {i.req_raised_by ? `${i.req_raised_by}` : "-"}
                                                    </td>


                                                    {role === "HOD" ?
                                                        <td className="align-right">
                                                            {!i.invoice_confirmation ?
                                                                <>
                                                                    {
                                                                        i.req_raised === "pending" && (
                                                                            <>
                                                                                <ApproveInvoiceEditRequest
                                                                                    i={i}
                                                                                    getInvoiceEditRequests={getInvoiceEditRequests}
                                                                                />
                                                                                <RejectInvoiceEditRequest
                                                                                    i={i}
                                                                                    getInvoiceEditRequests={getInvoiceEditRequests}
                                                                                />
                                                                            </>
                                                                        )
                                                                    }
                                                                    {i.req_raised === "approved" && (
                                                                        <RejectInvoiceEditRequest
                                                                            i={i}
                                                                            getInvoiceEditRequests={getInvoiceEditRequests}
                                                                        />
                                                                    )}
                                                                    {i.req_raised === "rejected" && (
                                                                        <ApproveInvoiceEditRequest
                                                                            i={i}
                                                                            getInvoiceEditRequests={getInvoiceEditRequests}
                                                                        />
                                                                    )}
                                                                </>
                                                                : "Invoice Finalized"
                                                            }
                                                        </td>
                                                        : null}
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};

export default RequestManagement;